import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

import { TestIDs } from 'test/utils/testIds'
import { style } from 'theme'
import trackEvent from 'utils/analytics/trackEvent'

import { getAccessibilityEventData } from './getAccessibilityEventData'

const AccessibilityContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const RightContainer = styled.div<{ setTop?: boolean; zIndex?: number }>`
  position: absolute;
  right: 30px;
  ${props => props.setTop && 'top: 30px;'}
  ${props => Number.isFinite(props.zIndex) && `z-index: ${props.zIndex};`}
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    right: 22px;
  }

  @media (max-width: 550px) {
    top: 22px;
  }
`

const WhiteIcon = styled(AcornsIcon)`
  path {
    fill: ${style(theme => theme.colors.white)};
  }
`

type componentProps = {
  logoColor?: 'white'
  children?: React.ReactNode
  zIndex?: number
}

export const Accessibility: React.FC<componentProps> = (props: componentProps) => {
  const handleOpenAccessibilityClick = () => {
    document.getElementById('INDmenu-btn')?.click()

    trackEvent('Button Tapped', {
      eventData: getAccessibilityEventData(),
    })
  }
  return (
    <RightContainer setTop={!props.children} zIndex={props.zIndex}>
      <AccessibilityContainer
        data-testid={TestIDs.ACCESSIBILITY.BUTTON}
        onClick={handleOpenAccessibilityClick}
      >
        {props.logoColor === 'white' ? (
          <WhiteIcon
            icon={AcornsIcon.Icon.UtilityAccessibilityFv}
            width="24px"
            height="24px"
            id="equal-web-toggle"
            aria-label="Open Accessibility Menu"
          />
        ) : (
          <AcornsIcon
            icon={AcornsIcon.Icon.UtilityAccessibilityFv}
            width="24px"
            height="24px"
            id="equal-web-toggle"
            aria-label="Open Accessibility Menu"
          />
        )}
      </AccessibilityContainer>
      {props.children}
    </RightContainer>
  )
}
